// removed by extract-text-webpack-plugin
module.exports = {"application-form-wrapper":"application-form-wrapper","react-tel-input":"react-tel-input","selected-flag":"selected-flag","flag":"flag","icon-cancel":"icon-cancel","PhoneNumberInput--country-list":"PhoneNumberInput--country-list"};


//////////////////
// WEBPACK FOOTER
// ./src/shared/RegisterClassModal/ApplicationForm.scss
// module id = /Tj7
// module chunks = 0